import Vue from "vue";
import moment from "moment";
import ApiService from "../../../../services/api";
import journeySynthetic from "./synthetic/journey-synthetic.vue";
import journeyDetail from "./detail/journey-detail.vue";
import journeyChart from "./chart/journey-chart.vue";
import { bus } from "../../../../main";
import { mapGetters } from 'vuex';
import helpers from "../../../../shared/fleetbox-helpers";

export default {
	components: {
		journeySynthetic,
		journeyDetail,
		journeyChart
	},
	data: function() {
		return {
			//#region filters
			filters: [
				{
					id: "timerange",
					items: [],
					value: {
						period: "0",
						startRange: moment(),
						endRange: moment()
					}
				},
				{
					id: "divisions",
					items: [],
					value: []
				},
				{
					id: "groups",
					items: [],
					value: []
				},
				{
					id: "vehicles",
					items: [],
					value: []
				}
			],
			//#endregion filters

			isSyntheticLoading: false,
			isChartLoading: false,
			isDetailLoading: false,

			headerSectionTitle: "",
			reportName: ""
		};
	},

	created() {
		var self = this;
		//#region filters
		this.filters[0].value.startRange = moment()
			.add(-7, "days")
			.startOf("day");
		this.filters[0].value.endRange = moment().endOf("day");
		//#endregion filters

		if (this.settings && this.settings.commonLabels && this.settings.commonLabels.key_report_estimated_label) {
			this.headerSectionTitle = ` - ${this.settings.commonLabels.key_report_estimated_label}`;
		}

		helpers.getReportName().then(res => {
			if (res) {
				var report = res.find(item => {
					return item.id == 220;
				});

				if (report) {
					self.reportName = report.name;
				}
				else {
					self.reportName = "PERCORRENZA";
				}
			}
		});

		bus.$emit("show-spinner-loading");
	},
	mounted() {
	},

	watch: {
		isChartLoading: {
			handler: function() {
				this.loadingProgressUpdate();
			}
		},
		isDetailLoading: {
			handler: function() {
				this.loadingProgressUpdate();
			}
		},
		isSyntheticLoading: {
			handler: function() {
				this.loadingProgressUpdate();
			}
		}
	},

	methods: {
		//#region loading progress
		loadingProgressUpdate() {
			if (this.isChartLoading || this.isDetailLoading || this.isSyntheticLoading) {
				bus.$emit("show-spinner-loading");
			}
			else {
				bus.$emit("hide-spinner-loading");
			}
		},
		onDetailLoading(isLoading) {
			this.isDetailLoading = isLoading;
		},
		onChartLoading(isLoading) {
			this.isChartLoading = isLoading;
		},
		onSyntheticLoading(isLoading) {
			this.isSyntheticLoading = isLoading;
		},
		//#endregion
		//#region filters events
		onFilterApplyClick() {
			if (this.$refs.syntheticJourneyReport) {
				this.$refs.syntheticJourneyReport.applyReportFilter();
			}

			if (this.$refs.detailJourneyReport) {
				this.$refs.detailJourneyReport.applyReportFilter();
			}

			if (this.$refs.chartJourneyReport) {
				this.$refs.chartJourneyReport.applyReportFilter();
			}
		},
		onFilterResetClick() {
			this.setDefaultFilters();
			this.onFilterApplyClick();
		},
		onFilterTimerangeChange(newValue) {
			var timeRangeFilter = this.filters.find(item => {
				return item.id == "timerange";
			});
			if (timeRangeFilter) {
				timeRangeFilter.value.startRange = moment(newValue.startDate);
				timeRangeFilter.value.endRange = moment(newValue.endDate);
			}
		},
		onFilterDivisionChange(newValue) {
			var divisionFilter = this.filters.find(item => {
				return item.id == "divisions";
			});
			if (divisionFilter) {
				Vue.set(divisionFilter, "value", newValue);
			}
		},
		onFilterGroupChange(newValue) {
			var groupFilter = this.filters.find(item => {
				return item.id == "groups";
			});
			if (groupFilter) {
				Vue.set(groupFilter, "value", newValue);
			}
		},
		onFilterPlateChange(newValue) {
			var vehiclesFilter = this.filters.find(item => {
				return item.id == "vehicles";
			});
			if (vehiclesFilter) {
				Vue.set(vehiclesFilter, "value", newValue);
			}
		},
		setDefaultFilters() {
			this.filters[0].value.period = "0";
			this.filters[0].value.startRange = moment()
				.add(-7, "days")
				.startOf("day");
			this.filters[0].value.endRange = moment().endOf("day");

			for (var i = 1; i < this.filters.length; i++) {
				var flt = this.filters[i];

				Vue.set(flt, "value", []);
			}
		}
		//#endregion filters events
	},
	computed: {
		...mapGetters(["settings"])
	}
};
